import(/* webpackMode: "eager" */ "/home/runner/work/nextjs-ims/nextjs-ims/app/global-error.tsx");
